import React, { useEffect } from "react"
import { Field, FieldArray } from "lib/formik"
import { Col, Row, Button, Input } from "reactstrap"
import Select from "react-select"
import Switch from "components/Shared/Switch"
import TextError from "components/Shared/TextError"

const CountryShipmentDetail = ({
  touched,
  errors,
  t,
  language,
  setFieldValue,
  values,
  zoneList,
}) => {
  const regionTypeOptions = [
    { label: t("Local"), value: "local" },
    { label: t("International"), value: "international" },
  ]

  const priorityLogicOptions = [
    { label: t("Actual Weight"), value: "actual_weight" },
    { label: t("Dynamic Weight"), value: "dynamic_weight" },
    { label: t("Max of both"), value: "max_of_both" },
  ]
  const defaultPriorityLogic = priorityLogicOptions[0]

  useEffect(() => {
    if (!values?.priorityLogic) {
      setFieldValue("priorityLogic", defaultPriorityLogic.value)
    }
  }, [values?.priorityLogic, defaultPriorityLogic.value, setFieldValue])

  return (
    <>
      <Col lg={12} className="mb-3">
        <h5 className="fw-bold">{t("Shipment and Packaging")}</h5>
      </Col>

      <Col lg={12} className="mb-3">
        <div className="form_field">
          <label htmlFor="regionType">
            <span className="text-danger">*</span> {t("Region Type")}
          </label>
          <Select
            name="regionType"
            options={regionTypeOptions}
            placeholder={t("Select Region Type")}
            className="select2-selection"
            value={regionTypeOptions.find(
              option => option.value === values.regionType
            )}
            onChange={({ value }) => {
              setFieldValue("regionType", value)
            }}
          />
          <TextError name="regionType" />
        </div>
      </Col>

      <Col lg={6} className="mb-3">
        <div className="form_field">
          <label htmlFor="fixedDeliveryCharge">
            <span className="text-danger">*</span> {t("Fixed Delivery Charge")}
          </label>
          <Field
            type="number"
            id="fixedDeliveryCharge"
            name="fixedDeliveryCharge"
            placeholder={t("Fixed Delivery Charge")}
            className={`form-control ${
              touched.fixedDeliveryCharge && errors.fixedDeliveryCharge
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="fixedDeliveryCharge" />
        </div>
      </Col>

      <Col lg={6} className="mb-3">
        <div className="form_field">
          <label htmlFor="freeDeliveryThreshold">
            <span className="text-danger">*</span>
            {t("Free Delivery Threshold")}
          </label>
          <Field
            type="number"
            id="freeDeliveryThreshold"
            name="freeDeliveryThreshold"
            placeholder={t("Free Delivery Threshold")}
            className={`form-control ${
              touched.freeDeliveryThreshold && errors.freeDeliveryThreshold
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="freeDeliveryThreshold" />
        </div>
      </Col>

      {/* <Col
        lg={12}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <div className="form-check form-switch">
          <label className="form-check-label" htmlFor="enableFreeDelivery">
            {t("Enable Free Delivery")}
          </label>
          <Input
            tag="input"
            type="checkbox"
            name="enableFreeDelivery"
            id="enableFreeDelivery"
            checked={values.enableFreeDelivery}
            onChange={e => {
              console.log({ e })
              setFieldValue("enableFreeDelivery", e.target.checked)
            }}
          />
        </div>
      </Col> */}

      <Col
        lg={12}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <label className="mb-0 me-2">{t("Enable Free Delivery")}</label>
        <Field name="enableFreeDelivery">
          {({ field, form }) => (
            <Switch
              isChecked={field.value}
              onClickHandler={() =>
                form.setFieldValue("enableFreeDelivery", !field.value)
              }
            />
          )}
        </Field>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="baseWeightLimit">
            <span className="text-danger">*</span>
            {t("Actual Base Weight Limit")}
          </label>
          <Field
            type="number"
            id="actualBaseWeightLimit"
            name="actualBaseWeightLimit"
            placeholder={t("Actual Base Weight Limit")}
            className={`form-control ${
              touched.actualBaseWeightLimit && errors.actualBaseWeightLimit
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="actualBaseWeightLimit" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="actualBaseRate">
            <span className="text-danger">*</span>
            {t("Actual Base Rate")}
          </label>
          <Field
            type="number"
            id="actualBaseRate"
            name="actualBaseRate"
            placeholder={t("Actual Base Rate")}
            className={`form-control ${
              touched.actualBaseRate && errors.actualBaseRate
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="actualBaseRate" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="actualExtraPerKgRate">
            <span className="text-danger">*</span>
            {t("Actual Extra Per KG Rate")}
          </label>
          <Field
            type="number"
            id="actualExtraPerKgRate"
            name="actualExtraPerKgRate"
            placeholder={t("Actual Extra Per KG Rate")}
            className={`form-control ${
              touched.actualExtraPerKgRate && errors.actualExtraPerKgRate
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="actualExtraPerKgRate" />
        </div>
      </Col>
      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="dynamicBaseWeightLimit">
            <span className="text-danger">*</span>
            {t("Dynamic Base Weight Limit")}
          </label>
          <Field
            type="number"
            id="dynamicBaseWeightLimit"
            name="dynamicBaseWeightLimit"
            placeholder={t("Dynamic Base Weight Limit")}
            className={`form-control ${
              touched.dynamicBaseWeightLimit && errors.dynamicBaseWeightLimit
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="dynamicBaseWeightLimit" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="dynamicBaseRate">
            <span className="text-danger">*</span>
            {t("Dynamic Base Rate")}
          </label>
          <Field
            type="number"
            id="dynamicBaseRate"
            name="dynamicBaseRate"
            placeholder={t("Dynamic Base Rate")}
            className={`form-control ${
              touched.dynamicBaseRate && errors.dynamicBaseRate
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="dynamicBaseRate" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="dynamicExtraPerKgRate">
            <span className="text-danger">*</span>
            {t("Dynamic Extra Per KG Rate")}
          </label>
          <Field
            type="umber"
            id="dynamicExtraPerKgRate"
            name="dynamicExtraPerKgRate"
            placeholder={t("Dynamic Extra Per KG Rate")}
            className={`form-control ${
              touched.dynamicExtraPerKgRate && errors.dynamicExtraPerKgRate
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="dynamicExtraPerKgRate" />
        </div>
      </Col>

      {/* <Col
        lg={6}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <div className="form-check form-switch">
          <label className="form-check-label" htmlFor="enableBoxFee">
            {t("Enable Box Fee")}
          </label>
          <Input
            type="checkbox"
            name="enableBoxFee"
            id="enableBoxFee"
            onChange={e => setFieldValue("enableBoxFee", !values.enableBoxFee)}
          />
        </div>
      </Col> */}

      <Col
        lg={12}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <label className="mb-0 me-2">{t("Enable Box Fee")}</label>
        <Field name="enableBoxFee">
          {({ field, form }) => (
            <Switch
              isChecked={field.value}
              onClickHandler={() =>
                form.setFieldValue("enableBoxFee", !field.value)
              }
            />
          )}
        </Field>
      </Col>

      <Col lg={6} className="mb-3">
        <div className="form_field">
          <label htmlFor="boxFee">
            <span className="text-danger">*</span>
            {t("Box Fee")}
          </label>
          <Field
            type="number"
            id="boxFee"
            name="boxFee"
            placeholder={t("Box Fee")}
            className={`form-control ${
              touched.boxFee && errors.boxFee ? "is-invalid" : ""
            }`}
          />
          <TextError name="boxFee" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="noOfBaseItemsLimit">
            <span className="text-danger">*</span>
            {t("No of Base Items Limit")}
          </label>
          <Field
            type="number"
            id="noOfBaseItemsLimit"
            name="noOfBaseItemsLimit"
            placeholder={t("No of Base Items Limit")}
            className={`form-control ${
              touched.noOfBaseItemsLimit && errors.noOfBaseItemsLimit
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="noOfBaseItemsLimit" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="baseFulfillmentFee">
            <span className="text-danger">*</span>
            {t("Base Fulfillment Fee")}
          </label>
          <Field
            type="number"
            id="baseFulfillmentFee"
            name="baseFulfillmentFee"
            placeholder={t("Base Fulfillment Fee")}
            className={`form-control ${
              touched.baseFulfillmentFee && errors.baseFulfillmentFee
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="baseFulfillmentFee" />
        </div>
      </Col>

      <Col sm={12} lg={4} className="mb-3">
        <div className="form_field">
          <label htmlFor="extraItemFee">
            <span className="text-danger">*</span>
            {t("Extra Item Fee")}
          </label>
          <Field
            type="number"
            id="extraItemFee"
            name="extraItemFee"
            placeholder={t("Extra Item Fee")}
            className={`form-control ${
              touched.extraItemFee && errors.extraItemFee ? "is-invalid" : ""
            }`}
          />
          <TextError name="extraItemFee" />
        </div>
      </Col>

      {/* <Col
        lg={6}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <div className="form-check form-switch">
          <label className="form-check-label" htmlFor="enableSurcharge">
            {t("Enable Surcharge")}
          </label>
          <Input
            type="checkbox"
            name="enableSurcharge"
            id="enableSurcharge"
            onChange={e =>
              setFieldValue("enableSurcharge", !values.enableSurcharge)
            }
          />
        </div>
      </Col> */}

      <Col
        lg={12}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <label className="mb-0 me-2"> {t("Enable Surcharge")}</label>
        <Field name="enableSurcharge">
          {({ field, form }) => (
            <Switch
              isChecked={field.value}
              onClickHandler={() =>
                form.setFieldValue("enableSurcharge", !field.value)
              }
            />
          )}
        </Field>
      </Col>

      <Col lg={6} className="mb-3">
        <div className="form_field">
          <label htmlFor="surchargeRate">
            <span className="text-danger">*</span>
            {t("Surcharge Rate (%)")}
          </label>
          <Field
            type="number"
            id="surchargeRate"
            name="surchargeRate"
            placeholder={t("Surcharge Rate (%)")}
            className={`form-control ${
              touched.surchargeRate && errors.surchargeRate ? "is-invalid" : ""
            }`}
          />
          <TextError name="surchargeRate" />
        </div>
      </Col>

      {/* <Col
        lg={6}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <div className="form-check form-switch">
          <label className="form-check-label" htmlFor="enableDynamicCalc">
            {t("Enable Dynamic Calc")}
          </label>
          <Input
            type="checkbox"
            name="enableDynamicCalc"
            id="enableDynamicCalc"
            onChange={e =>
              setFieldValue("enableDynamicCalc", !values.enableDynamicCalc)
            }
          />
        </div>
      </Col> */}
      <Col
        lg={12}
        className="mb-3 flex align-items-center justify-content-start"
      >
        <label className="mb-0 me-2"> {t("Enable Dynamic Calc")}</label>
        <Field name="enableDynamicCalc">
          {({ field, form }) => (
            <Switch
              isChecked={field.value}
              onClickHandler={() =>
                form.setFieldValue("enableDynamicCalc", !field.value)
              }
            />
          )}
        </Field>
      </Col>

      <Col lg={6} className="mb-3">
        <div className="form_field">
          <label htmlFor="volumetricDivisor">
            <span className="text-danger">*</span>
            {t("Volumetric Divisor")}
          </label>
          <Field
            type="number"
            id="volumetricDivisor"
            name="volumetricDivisor"
            placeholder={t("Volumetric Divisor")}
            className={`form-control ${
              touched.volumetricDivisor && errors.volumetricDivisor
                ? "is-invalid"
                : ""
            }`}
          />
          <TextError name="volumetricDivisor" />
        </div>
      </Col>

      <Col lg={12} className="mb-3">
        <div className="form_field">
          <label htmlFor="priorityLogic">
            <span className="text-danger">*</span>
            {t("Priority Logic")}
          </label>
          <Select
            value={
              priorityLogicOptions.find(
                option => option.value === values.priorityLogic
              ) || defaultPriorityLogic
            }
            onChange={item => {
              setFieldValue("priorityLogic", item.value)
            }}
            isDisabled={true}
            options={priorityLogicOptions}
            className={`select2-selection ${
              touched.priorityLogic && errors.priorityLogic ? "is-invalid" : ""
            }`}
            placeholder={t("Select Priority Logic")}
          />
          <TextError name="priorityLogic" />
        </div>
      </Col>
    </>
  )
}

export default CountryShipmentDetail
